import React, { useEffect, useState } from 'react';
import { getData, handleError } from '../../functions/services';
import Loader from '../common/Loader';
import * as FaIcons from 'react-icons/fa';
import { formatDateToLocal } from '../../functions/dates';

const ModalProyectsRanking = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const req = await getData('reports/proyects-ranking', {});
            setData(req.data);
            setLoading(false);
        } catch (error) {
            console.log(error);
            handleError(error);
        }
    };

    const renderTable = () => {
        const tableData = data.map((val, i) => {
            return (
                <tr key={i}>
                    <td>{`${val.company.name}-${val.city}-${formatDateToLocal(val.createdAt)}`}</td>
                    <td className="tac">{val.points.toFixed(1)}</td>
                    <td className="tac">{i + 1}</td>
                </tr>
            );
        });

        return (
            <>
                <table className="table table-striped">
                    <thead className="tac">
                        <tr>
                            <th>Nombre</th>
                            <th>Ptos</th>
                            <th>#</th>
                        </tr>
                    </thead>
                    <tbody>{tableData}</tbody>
                </table>
            </>
        );
    };

    return (
        <div>
            <div className="p-2 modal-title">
                Ranking de proyectos
                <FaIcons.FaCrown className="float-right" />
            </div>

            {loading ? (
                <div className="center-flex">
                    <Loader />
                </div>
            ) : (
                renderTable()
            )}
        </div>
    );
};

export default ModalProyectsRanking;
